import styled from 'styled-components'
import React from 'react'
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native'
import { colors } from 'infra/color'
import { Body1 } from 'ui/common/text'
import { Category } from 'infra/type'
import { ButtonShadow } from 'ui/home/bottom-button-styles.ts'

export const CategoryChip: React.FC<{
  data: Category
  onPress?: () => void
  isActive: boolean
  isSelected: boolean
  containerStyle?: StyleProp<ViewStyle>
  touchDisabled?: boolean
}> = ({
  data,
  onPress,
  isActive,
  isSelected,
  containerStyle,
  touchDisabled,
}) => {
  return (
    <Container
      disabled={touchDisabled}
      onPress={onPress}
      isActive={isActive}
      isSelected={isSelected}
      style={[containerStyle, ButtonShadow]}
    >
      <InnerText isActive={isActive} isSelected={isSelected}>
        {data.name}
      </InnerText>
    </Container>
  )
}

const FILL_COLOR = {
  // active / inactive
  true: {
    // selected / unselected
    true: colors.primary,
    false: colors.white,
  },
  false: {
    true: colors.gray.v700,
    false: colors.white,
  },
}

const TEXT_COLOR = {
  true: {
    true: colors.white,
    false: colors.black,
  },
  false: {
    true: colors.white,
    false: colors.gray.v700,
  },
}

const Container = styled(TouchableOpacity)<{
  isActive: boolean
  isSelected: boolean
}>`
  padding: 8px 16px;
  border-radius: 999px;
  background-color: ${({ isActive, isSelected }) =>
    // @ts-ignore
    FILL_COLOR[String(isActive)][String(isSelected)]};
  margin: 0 6px 8px 0;
  flex-direction: row;
  align-items: center;
`

const InnerText = styled(Body1)<{
  isActive: boolean
  isSelected: boolean
}>`
  font-weight: 700;
  color: ${({ isActive, isSelected }) =>
    // @ts-ignore
    TEXT_COLOR[String(isActive)][String(isSelected)]};
`
